module.exports = __webpack_public_path__ + "static/img/SelectTopic.fa244dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/SelectTopic.png
// module id = BGAw
// module chunks = 24